import { create } from 'zustand';
import i18n from 'i18n';
import { saveAs } from 'file-saver';
import { ApiUtils, StatementsApi } from '@shared/api';

interface UseDownloadStatementsStore {
  loading: boolean;
  data: any[] | null;
  error?: string | null;
  downloadStatements: (record: any) => Promise<void>;
  clear: () => void;
}

export const useDownloadStatementsStore = create<UseDownloadStatementsStore>((set) => ({
  loading: false,
  data: null,
  error: null,

  downloadStatements: async (record: any) => {
    try {
      set({ loading: true, error: null });
      const blob = await StatementsApi.downloadStatement(record.accountId, record.year, record.intMonth);
      saveAs(blob, `${record.month}.pdf`);
      set({ loading: false });
    } catch (e) {
      const error = i18n.t(`errors.api.${ApiUtils.getError(e)}`, ApiUtils.getError(e));
      set({ loading: false, error });
    }
  },

  clear: () => set({ loading: false, data: null, error: null }),
}));
